import {required} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrPerfTablolarDetayParametreTanim = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrPerfTablolarDetayParametreTanimData:{
            Id: "",
            Parametreadi: "",
            Deleted: false,
            Tip: "",
            Comboboxveribaslikid: ""
          },
        FormDataType:{ 
          Parametreadi:{FieldName:"Parametreadi",Field:"input",FieldTitle:this.$t('StrPerfTablolarDetayParametreTanim.AddEdit.Parametreadi'),FieldType:"text"},
          Tip:{FieldName:"Tip",Field:"combobox",FieldTitle:this.$t('StrPerfTablolarDetayParametreTanim.AddEdit.Tip'),ComboDataArray:[]},
          Comboboxveribaslikid:{FieldName:"Comboboxveribaslikid",Field:"combobox",FieldTitle: this.$t('StrPerfTablolarDetayParametreTanim.AddEdit.Comboboxveribaslikid'),ComboDataArray:[]},
        },
   
      }
    },
    validations:{ 
        FormData: {
            Parametreadi: { required },
            Tip: { required },
            Comboboxveribaslikid: {}
        } 
    },


    created(){ 
      let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }

      let Filter = "&Tip=1558";
            
      this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:Filter}).then((res) => {
          for(var i=0; i<res.Data.length; i++)
          {
              this.FormDataType.Tip.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})   
          }
        
      });     
      

       this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametreHedefTanim", Page: Page, Filter: "&UstidDoluMu=false" }).then((resp) => {
        for(var d in resp.Data)
          {
              this.FormDataType.Comboboxveribaslikid.ComboDataArray.push ({Id:resp.Data[d].Id,Value:resp.Data[d].Hedefadi})   
          }
     });
    }


}
export default StrPerfTablolarDetayParametreTanim